import React from "react";

export default function RequiredFieldsSubheader() {
    return <span className="required-fields-subheader">* Required Fields</span>;
}
